import { render, staticRenderFns } from "./ContactRelationshipModal.vue?vue&type=template&id=680d1f4a&scoped=true&lang=pug"
import script from "./ContactRelationshipModal.vue?vue&type=script&lang=js"
export * from "./ContactRelationshipModal.vue?vue&type=script&lang=js"
import style0 from "./ContactRelationshipModal.vue?vue&type=style&index=0&id=680d1f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680d1f4a",
  null
  
)

export default component.exports